var exports = {
  "fs": "SpaceBackground.module__starfield___Q2puVD",
  "UB": "SpaceBackground.module__starDrift___Q2puVD",
  "hi": "SpaceBackground.module__spaceBackground___Q2puVD" + " " + "SpaceBackground.module__starfield___Q2puVD",
};

module.exports = exports;
